import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Custom twMerge instance configured with Homy's design system tokens.
 * Extends the font-size class group to recognize custom typography scale utilities
 * (text-overline, text-caption, etc.) and prevents collisions with text-* color utilities.
 */
export const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'overline',
            'overline-size',
            'overline-medium',
            'caption',
            'caption-size',
            'label',
            'display-2xs',
          ],
        },
      ],
      rounded: [
        {
          rounded: [
            'card',
            'modal',
          ],
        },
      ],
    },
  },
});

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx and custom twMerge for optimal class handling
 */
export function cn(...inputs) {
  return customTwMerge(clsx(inputs));
}

export { customTwMerge as twMerge };

/**
 * Strips superfluous trailing decimals (e.g. 1275000.00 -> "1275000")
 * while preserving actual fractional values (e.g. 12.5 -> "12.5").
 */
export function cleanCurrencyAmount(val) {
  if (val == null || val === "") return "";
  const num = typeof val === "number" ? val : parseFloat(val);
  if (isNaN(num)) return String(val);
  return num % 1 === 0 ? String(Math.round(num)) : String(num);
}
